import _replace from "ramda/es/replace";
export default _replace(/\D/g, '');